import { newNotification } from "@kontextwerk/web-sdk/core/overlay/notifications"

import { getApiError, type KehrblattApiError } from "../../../../../../../api/error-handling"

type ApiErrorNotificationOptions = {
  includeRequestId?: boolean
  class?: "error" | "warning" | "success" | "info"
  timeout?: number
  removeOnNewLocation?: boolean
  blockUI?: boolean
}

const DEFAULT_FALLBACK = "Die Aktion konnte nicht ausgeführt werden."

const escapeHtml = (value: string): string =>
  value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;")

export const showApiErrorNotification = (
  error: unknown,
  fallback = DEFAULT_FALLBACK,
  options: ApiErrorNotificationOptions = {},
): KehrblattApiError => {
  const normalized = getApiError(error, fallback)
  const requestId =
    options.includeRequestId && normalized.requestId
      ? `<br><small>Fehler-ID: ${escapeHtml(normalized.requestId)}</small>`
      : ""
  newNotification({
    class: options.class ?? "error",
    html: `${escapeHtml(normalized.message)}${requestId}`,
    timeout: options.timeout,
    removeOnNewLocation: options.removeOnNewLocation,
    blockUI: options.blockUI,
  })

  return normalized
}
